import React from 'react';
import { motion } from 'framer-motion';
export function About() {
  return <section id="about" className="py-24 bg-[#0A0A0A] overflow-hidden" data-id="element-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-13">
        <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-14">
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="w-full lg:w-1/2 relative" data-id="element-15">
            <div className="relative z-10 w-full h-[600px] border border-[#2A2A2A] bg-[#111111] flex items-center justify-center p-12 text-center rounded-sm shadow-lg" data-id="element-16">
              <h3 className="text-3xl md:text-4xl text-[#D4AF37] font-serif italic" data-id="element-17">
                "A sanctuary for holistic wellness and relaxation."
              </h3>
            </div>
            {/* Decorative background element */}
            <div className="absolute -bottom-8 -left-8 w-full h-full border-2 border-[#D4AF37] rounded-sm z-0 hidden md:block" data-id="element-18"></div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="w-full lg:w-1/2" data-id="element-19">
            <h2 className="text-4xl md:text-5xl text-[#F5F0EB] mb-6" data-id="element-20">
              Our Philosophy
            </h2>
            <div className="h-1 bg-[#D4AF37] w-20 mb-8" data-id="element-21" />

            <p className="text-lg text-[#999999] mb-6 leading-relaxed" data-id="element-22">
              At Serenity Spa & Massage, we believe that true wellness comes
              from a harmonious balance of mind, body, and spirit. Our sanctuary
              was created to provide an escape from the demands of modern life.
            </p>
            <p className="text-lg text-[#999999] mb-10 leading-relaxed" data-id="element-23">
              Every treatment is tailored to your unique needs by our highly
              trained therapists, using only the finest organic oils and
              holistic techniques to ensure a deeply restorative experience.
            </p>

            <div className="grid grid-cols-2 gap-8" data-id="element-24">
              <div data-id="element-25">
                <h4 className="text-4xl text-[#D4AF37] mb-2 font-serif" data-id="element-26">15+</h4>
                <p className="text-[#F5F0EB] font-medium uppercase tracking-wider text-sm" data-id="element-27">
                  Years Experience
                </p>
              </div>
              <div data-id="element-28">
                <h4 className="text-4xl text-[#D4AF37] mb-2 font-serif" data-id="element-29">
                  10k+
                </h4>
                <p className="text-[#F5F0EB] font-medium uppercase tracking-wider text-sm" data-id="element-30">
                  Happy Clients
                </p>
              </div>
              <div data-id="element-31">
                <h4 className="text-4xl text-[#D4AF37] mb-2 font-serif" data-id="element-32">5.0</h4>
                <p className="text-[#F5F0EB] font-medium uppercase tracking-wider text-sm" data-id="element-33">
                  Star Rating
                </p>
              </div>
              <div data-id="element-34">
                <h4 className="text-4xl text-[#D4AF37] mb-2 font-serif" data-id="element-35">12</h4>
                <p className="text-[#F5F0EB] font-medium uppercase tracking-wider text-sm" data-id="element-36">
                  Expert Therapists
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}